import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/logo_update.png'
import _imports_1 from '@/assets/logo.png'


const _hoisted_1 = {
  key: 0,
  class: "navbar"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "brain tree"
}, null, -1)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Next Level!",
  class: "logo"
}, null, -1)
const _hoisted_5 = { class: "nav-pills" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "brain tree well being",
    class: "logo"
  })
], -1)
const _hoisted_7 = {
  key: 1,
  class: "medium-width-centered"
}

import api from "@virgodev/bazaar/functions/api";
import { storeToRefs } from "pinia";
import { ref, watch } from "vue";
import UserProfilePhoto from "@/components/users/UserProfilePhoto.vue";
import { useStore } from "@/store";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();
const { loggedIn, userData } = storeToRefs(store);

watch(loggedIn, () => {
  if (loggedIn.value) {
    document.body.classList.add("app-logged-in");
    document.body.classList.remove("app-logged-out");
  } else {
    document.body.classList.remove("app-logged-in");
    document.body.classList.add("app-logged-out");
  }
});

const appLaunchDataStatus = ref<"loading" | "loaded" | "error">("loading");

async function loadAppLaunchData() {
  appLaunchDataStatus.value = "loading";

  const responseData = await api({ url: "app-launch/" });

  if (responseData.status === 200) {
    if (responseData.body.user_data !== undefined) {
      store.logIn(responseData.body.user_data);
    }

    appLaunchDataStatus.value = "loaded";
    document.body.classList.remove("app-not-launched");

    if (responseData.body.user_data !== undefined) {
      const organizationData = await api({ url: "organizations/" });

      if (organizationData.status === 200) {
        store.setOrganization(organizationData.body[0]);
      }
    }
  } else {
    appLaunchDataStatus.value = "error";
  }
}

async function main() {
  loadAppLaunchData();
}

main();

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (appLaunchDataStatus.value === 'loaded')
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_unref(loggedIn))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_RouterLink, {
                to: { name: 'home' },
                class: "navbar-logo-link"
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createElementVNode("nav", null, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", {
                    class: _normalizeClass({ active: String(_ctx.$route.name).startsWith('home') })
                  }, [
                    _createVNode(_component_RouterLink, { to: { name: 'home' } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_FontAwesomeIcon, { icon: "fa-solid fa-house" }),
                        _createTextVNode(" Home ")
                      ]),
                      _: 1
                    })
                  ], 2),
                  _createElementVNode("li", {
                    class: _normalizeClass({
              active: String(_ctx.$route.name).startsWith('resources'),
            })
                  }, [
                    _createVNode(_component_RouterLink, { to: { name: 'resources' } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_FontAwesomeIcon, { icon: "fa-solid fa-photo-film" }),
                        _createTextVNode(" Resource Library ")
                      ]),
                      _: 1
                    })
                  ], 2),
                  (
              ['org_admin', 'loc_admin'].includes(_unref(userData).role) ||
              ['school_leader', 'para', 'teacher'].includes(_unref(userData).sub_role)
            )
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 0,
                        class: _normalizeClass({
              active: String(_ctx.$route.name).startsWith('reports'),
            })
                      }, [
                        _createVNode(_component_RouterLink, { to: { name: 'reports' } }, {
                          default: _withCtx(() => [
                            _createVNode(_component_FontAwesomeIcon, { icon: "fa-solid fa-chart-pie" }),
                            _createTextVNode(" Reports ")
                          ]),
                          _: 1
                        })
                      ], 2))
                    : _createCommentVNode("", true),
                  (
              _unref(userData).sub_role === 'para' ||
              _unref(userData).sub_role == 'school_leader'
            )
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 1,
                        class: _normalizeClass({
              active: String(_ctx.$route.name).startsWith('check_ins'),
            })
                      }, [
                        _createVNode(_component_RouterLink, { to: { name: 'check_ins' } }, {
                          default: _withCtx(() => [
                            _createVNode(_component_FontAwesomeIcon, { icon: "fa-solid fa-check-to-slot" }),
                            _createTextVNode(" Check-Ins ")
                          ]),
                          _: 1
                        })
                      ], 2))
                    : _createCommentVNode("", true),
                  (
              _unref(userData).sub_role === 'para' ||
              _unref(userData).sub_role == 'school_leader'
            )
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 2,
                        class: _normalizeClass({
              active: String(_ctx.$route.name).startsWith('coping_tools'),
            })
                      }, [
                        _createVNode(_component_RouterLink, { to: { name: 'coping_tools' } }, {
                          default: _withCtx(() => [
                            _createVNode(_component_FontAwesomeIcon, { icon: "fa-solid fa-toolbox" }),
                            _createTextVNode(" Coping Tools ")
                          ]),
                          _: 1
                        })
                      ], 2))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", {
                    class: _normalizeClass({
              active: String(_ctx.$route.name).startsWith('zoom'),
            })
                  }, [
                    _createVNode(_component_RouterLink, { to: { name: 'zoom' } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_FontAwesomeIcon, { icon: "fa-solid fa-desktop" }),
                        _createTextVNode(" Training ")
                      ]),
                      _: 1
                    })
                  ], 2),
                  (
              ['loc_admin', 'org_admin'].includes(_unref(userData).role) ||
              ['para', 'school_leader', 'teacher'].includes(_unref(userData).sub_role)
            )
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 3,
                        class: _normalizeClass({
              active: String(_ctx.$route.name).startsWith('positive_experiences'),
            })
                      }, [
                        _createVNode(_component_RouterLink, { to: { name: 'positive_experiences' } }, {
                          default: _withCtx(() => [
                            _createVNode(_component_FontAwesomeIcon, { icon: "fa-solid fa-thumbs-up" }),
                            _createTextVNode(" Positive Experiences ")
                          ]),
                          _: 1
                        })
                      ], 2))
                    : _createCommentVNode("", true),
                  (['org_admin', 'loc_admin'].includes(_unref(userData).role))
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 4,
                        class: _normalizeClass({
              active: String(_ctx.$route.name).startsWith('administrators'),
            })
                      }, [
                        _createVNode(_component_RouterLink, { to: { name: 'administrators' } }, {
                          default: _withCtx(() => [
                            _createVNode(_component_FontAwesomeIcon, { icon: "fa-solid fa-users" }),
                            _createTextVNode(" Administrators ")
                          ]),
                          _: 1
                        })
                      ], 2))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("header", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("nav", _hoisted_5, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_RouterLink, { to: { name: 'login' } }, {
                      default: _withCtx(() => [
                        _createTextVNode("Log In")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])),
        _createElementVNode("main", {
          class: _normalizeClass({ contain: !String(_ctx.$route.name).startsWith('resources') })
        }, [
          (_unref(loggedIn))
            ? (_openBlock(), _createBlock(_component_RouterLink, {
                key: 0,
                to: { name: 'account' },
                class: "account-link"
              }, {
                default: _withCtx(() => [
                  _createVNode(UserProfilePhoto, { user: _unref(userData) }, null, 8, ["user"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_RouterView, null, {
            default: _withCtx(({ Component }) => [
              (_openBlock(), _createBlock(_KeepAlive, { include: [] }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                  key: _ctx.$route.path
                }))
              ], 1024))
            ]),
            _: 1
          })
        ], 2)
      ], 64))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _hoisted_6,
        _createElementVNode("main", null, [
          (appLaunchDataStatus.value === 'loading')
            ? (_openBlock(), _createBlock(_component_BaseSpinner, {
                key: 0,
                preset: "large"
              }))
            : (appLaunchDataStatus.value === 'error')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_BaseAlert, { variant: "danger" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Unable to communicate with the server. Please check your connection. ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_BaseButton, { onClick: loadAppLaunchData }, {
                    default: _withCtx(() => [
                      _createTextVNode("Try Again")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
        ])
      ], 64))
}
}

})